import * as z from "zod";

export const UserSchema = z.object({
  id: z.string(),
  email: z.string(),
  username: z.string().nullable().optional(),
  fullname: z.string().nullable().optional(),
  profilePicture: z.string().nullable().optional(),
});

export const TeamMembershipSchema = z.object({
  id: z.string(),
  userId: z.string(),
  teamId: z.string(),
  role: z.string(),
  status: z.string(),
  user: UserSchema.nullable().optional(),
});

export const UserWithTeamMembershipListSchema = z.object({
  id: z.string(),
  email: z.string(),
  username: z.string().nullable().optional(),
  fullname: z.string().nullable().optional(),
  profilePicture: z.string().nullable().optional(),
  teamMembershipList: z.array(TeamMembershipSchema),
});

export type User = z.infer<typeof UserSchema>;
export type TeamMembership = z.infer<typeof TeamMembershipSchema>;
export type UserWithTeamMembershipList = z.infer<typeof UserWithTeamMembershipListSchema>;
